<template>
  <div>
    <b-row class="mb-2 align-items-center" v-for="(item, index) in getLogisticProofOfImage()"
      :key="`logistic-proof-of-image-${index}`">
      <b-col cols="6" md="2" class="details-label">{{ item.label }}</b-col>
      <b-col cols="6" md="10">
        <b-button variant="link" class="p-0" @click="handleProofOfImageModal(item)">
          View Photo
        </b-button>
      </b-col>
    </b-row>
    <ProofOfImageModal />
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
import ProofOfImageModal from "./ProofOfImageModal.vue";

export default {
  props: ["order"],
  components: { ProofOfImageModal },
  computed: {
    ...mapState("estore", ["proofOfLogisticsData"])
  },
  methods: {
    getLogisticProofOfImage() {
      const { proof_of_pickup, proof_of_delivery, proof_of_return } = _.get(this.order, "grab_delivery", {}) || {};
      const getTime = (key) => {
        const [date, time] = decodeURI((key).split("_")[1].split(".")[0]).split(" ");
        return `${date} ${time.replace(/%3A/g, ":")}`;
      };
      return [
        proof_of_pickup && {
          label: "Proof of Pickup",
          image: proof_of_pickup,
          timestamp: getTime(proof_of_pickup)
        },
        proof_of_delivery && {
          label: "Proof of Delivery",
          image: proof_of_delivery,
          timestamp: getTime(proof_of_delivery)
        },
        proof_of_return && {
          label: "Proof of Return",
          image: proof_of_return,
          timestamp: getTime(proof_of_return)
        }
      ].filter(item => item);
    },
    handleProofOfImageModal(item) {
      this.$store.state.estore.proofOfLogisticsData = item;
      this.$root.$emit("bv::show::modal", "logistic-proof-image-modal");
    }
  }
}
</script>

<style lang="scss" scoped>
.details-label {
  font-size: 16px;
  @extend .mainFontBold;
}

.btn-link {

  &:hover,
  &:active,
  &:focus-within {
    text-decoration: none;
  }
}
</style>
